import { Container, Card, CardBody, CardTitle, ListGroup, ListGroupItem, CardHeader } from 'reactstrap';
import './About.css';

function About() {
  return (
    <Container id="about" className="my-5">
      <Card>
        <CardHeader>
          <CardTitle tag="h2">
            About Me:
          </CardTitle>
        </CardHeader>
        <CardBody>
          <ListGroup>
            <ListGroupItem>3rd Year Software Engineering student at RIT</ListGroupItem>
            <ListGroupItem>Extensive experience with web design and development</ListGroupItem>
            <ListGroupItem>A strong focus on communications and team dynamics</ListGroupItem>
            <ListGroupItem>Hands-on practice with secure coding and vulnerability assessment</ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </Container>
  );
}

export default About;